import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice'; // We will create this next
import  userReducer  from './userSlice';
import playerReducer from './playerSlice';
import gameReducer from './gameSlice';

const store = configureStore({
    reducer: {
        auth: authReducer, // Adding the auth reducer
        user: userReducer,
        player: playerReducer,
        game: gameReducer
    },
});

export default store;